import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const PublicYellowBanner = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check for existing session (anonymous or regular)
    supabase.auth.getSession().then(({ data }) => {
      setIsAuthenticated(!!data.session);
    });

    // Listen for auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="bg-yellow-400 border-b-2 border-yellow-600 shadow-md relative z-10">
      <div className="container mx-auto flex justify-center">
        <div className="relative inline-flex items-center gap-1 md:gap-2 justify-center px-4 md:px-8 py-2 md:py-3">
          <a href="https://unravelyou.online/dashboard" className="flex items-center gap-1 md:gap-2 hover:opacity-80 transition-opacity">
            <span className="text-2xl md:text-6xl lg:text-7xl font-bold text-black drop-shadow-[0_2px_4px_rgba(0,0,0,0.2)]">UnravelYou</span>
            <span className="text-lg md:text-4xl lg:text-5xl text-black/50">-</span>
            <span className="text-lg md:text-4xl lg:text-5xl font-medium text-black/80 whitespace-nowrap">Discover your Path</span>
          </a>
          <div className="absolute bottom-0 right-2 md:bottom-1.5 md:right-4 flex items-center gap-2 pt-1">
            <a href="/about" className="text-[10px] md:text-sm text-white underline opacity-90 hover:opacity-100 transition-opacity" style={{ textShadow: '0 0 3px #000000' }}>About</a>
            <span className="text-white/40 hidden md:inline">|</span>
            <a href="/get-started" className="text-[10px] md:text-sm text-red-500 underline opacity-90 hover:opacity-100 transition-opacity">Get Started</a>
            <span className="text-white/40 hidden md:inline">|</span>
            <a href="/mission-guide" className="text-[10px] md:text-sm text-white underline opacity-90 hover:opacity-100 transition-opacity" style={{ textShadow: '0 0 3px #000000' }}>Mission Guide</a>
            <span className="text-white/40 hidden md:inline">|</span>
            <a href="/celebrity-readings" className="text-[10px] md:text-sm text-red-500 underline opacity-90 hover:opacity-100 transition-opacity">Celebrity Readings</a>
            {isAuthenticated && (
              <>
                <span className="text-white/40 hidden md:inline">|</span>
                <a href="/dashboard" className="text-[10px] md:text-sm text-green-600 font-semibold underline opacity-90 hover:opacity-100 transition-opacity">✨ Explore</a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
